import { useEffect, useState } from "react";
import {
  Button,
  MenuItem,
  CircularProgress,
  Grid,
  InputLabel,
  FormControl,
  Box,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormLabel,
  IconButton,
} from "@mui/material";
import Select from "@mui/material/Select";
import Iconify from "../iconify";
import { createBlobInContainer } from "src/utils/azureBlob";
import { nhlPackTypes } from "src/utils/cardUtils";
import { get, post, put } from "src/utils/networkUtils";

const defaultItem = {
  name: "",
  description: "",
  image: "",
  productId: "",
  amount: "",
  store: 0,
};
export default function StoreItemDialog(props) {
  const [packTypes, setPackTypes] = useState([]);
  const [versusPackTypes, setVersusPackTypes] = useState([]);
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props?.item) {
      setItem({
        ...props.item,
        status: props.item.IsActive ? "1" : "0",
      });
    } else {
      setItem(defaultItem);
    }
    get(`/admin/packs/types`).then(function (response) {
      setLoading(false);
      setVersusPackTypes(response.versusPackTypes);
      setPackTypes(
        response.packTypes.filter((pack) => nhlPackTypes.includes(pack.value))
      );
    });
  }, [props.item]);
  const handleChange = (e) => {
    const { id, value } = e.target;
    setItem((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const onSuccess = () => {
    item.tenantId = 1;
    if (props?.item) {
      put(
        `/admin/marketplace/store-items/${item.marketplaceStoreItemId}`,
        item
      ).then(function (response) {
        props.onSuccessHandler();
      });
    } else {
      post(`/admin/marketplace/store-items`, item).then(function (response) {
        props.onSuccessHandler();
      });
    }
  };
  const onCancel = () => {
    props.onClose();
  };

  const uploadFiles = (event, name) => {
    if (event.target.files.length > 0) {
      const files = event.target.files;

      let uploadPromises = [];
      uploadPromises.push(createBlobInContainer(files[0]));

      if (uploadPromises.length > 0) {
        const uploadFiles = async () => {
          await Promise.all(uploadPromises);

          const containerName = process.env.REACT_APP_STORAGE_CONTAINER;
          const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME;
          setItem((prevState) => ({
            ...prevState,
            [name]: `https://${storageAccountName}.blob.core.windows.net/${containerName}/${files[0].name}`,
          }));
        };

        uploadFiles().catch(console.error);
      }
    }
  };
  console.log(item);
  return (
    <Dialog
      open={props.open}
      onClose={() => {}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Store Item</DialogTitle>
      <DialogContent>
        {item === null || loading ? (
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Grid container>
            <Grid item xs={12} sx={{ m: 0, p: 1 }}>
              <TextField
                id="productId"
                label="Product ID"
                fullWidth
                value={item.productId}
                variant="standard"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4} sx={{ m: 0, p: 1 }}>
              <TextField
                id="name"
                label="Name"
                fullWidth
                value={item.name}
                variant="standard"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4} sx={{ m: 0, p: 1 }}>
              <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
                <InputLabel id="demo-simple-select-label">Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={item.itemType}
                  label="Store"
                  onChange={(event) =>
                    setItem((prevState) => ({
                      ...prevState,
                      itemType: event.target.value,
                    }))
                  }
                >
                  <MenuItem value="0" key={`store-0`}>
                    Coins
                  </MenuItem>
                  <MenuItem value="1" key={`store-1`}>
                    Pack
                  </MenuItem>
                  <MenuItem value="2" key={`store-2`}>
                    AllAccessPass
                  </MenuItem>
                  <MenuItem value="3" key={`store-3`}>
                    Versus Pack
                  </MenuItem>
                  <MenuItem value="4" key={`store-4`}>
                    Ticket
                  </MenuItem>
                  <MenuItem value="5" key={`store-5`}>
                    MonthlyAllAccessPass
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {item.itemType === "1" && (
              <Grid item xs={4} sx={{ m: 0, p: 1 }}>
                <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
                  <InputLabel id="demo-simple-select-label">
                    Pack Type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={item.packType}
                    label="Store"
                    onChange={(event) =>
                      setItem((prevState) => ({
                        ...prevState,
                        packType: event.target.value,
                      }))
                    }
                  >
                    {packTypes.map((packType, index) => (
                      <MenuItem value={packType.value} key={`store-0`}>
                        {packType.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
            {item.itemType === "3" && (
              <Grid item xs={4} sx={{ m: 0, p: 1 }}>
                <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
                  <InputLabel id="demo-simple-select-label">
                    Pack Type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={item.packType}
                    label="Store"
                    onChange={(event) =>
                      setItem((prevState) => ({
                        ...prevState,
                        packType: event.target.value,
                      }))
                    }
                  >
                    {versusPackTypes.map((packType, index) => (
                      <MenuItem value={packType.value} key={`store-0`}>
                        {packType.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
            <Grid item xs={6} sx={{ m: 0, p: 1 }}>
              <FormControl fullWidth sx={{ m: 0 }} size="small">
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Status"
                  value={item.IsActive ? "1" : "0"}
                  onChange={(e) =>
                    setItem((prev) => ({
                      ...prev,
                      IsActive: String(e.target.value) === "1",
                    }))
                  }
                >
                  <MenuItem value="0">Inactive</MenuItem>
                  <MenuItem value="1">Active</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sx={{ m: 0, p: 1 }}>
              <TextField
                id="description"
                label="Description"
                fullWidth
                value={item.description}
                variant="standard"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={3} sx={{ m: 0, p: 1 }}>
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-simple-select-label">Store</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={item.store}
                  label="Store"
                  onChange={(event) =>
                    setItem((prevState) => ({
                      ...prevState,
                      store: event.target.value,
                    }))
                  }
                >
                  <MenuItem value="0" key={`store-0`}>
                    Apple
                  </MenuItem>
                  <MenuItem value="1" key={`store-1`}>
                    Google
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} sx={{ m: 0, p: 1 }}>
              <TextField
                id="amount"
                label="Coins Amount"
                fullWidth
                value={item.amount}
                variant="standard"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={3} sx={{ m: 0, p: 1 }}>
              <TextField
                id="price"
                label="Price Label (Android)"
                fullWidth
                value={item.price}
                variant="standard"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={3} sx={{ m: 0, p: 1 }}>
              <TextField
                id="priceValue"
                label="Price Value"
                fullWidth
                value={item.priceValue}
                variant="standard"
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={6}>
              <FormLabel id="card-format-label">Image</FormLabel>
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="label"
              >
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  onChange={(event) => uploadFiles(event, "image")}
                />
                <Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
              </IconButton>
              {item.image ? (
                <img
                  style={{
                    margin: "0 auto",
                    width: 100,
                    background: "grey",
                  }}
                  alt="Store Item"
                  src={item.image}
                />
              ) : null}
            </Grid>
            <Grid item xs={6}>
              <FormLabel id="card-format-label">List Image</FormLabel>
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="label"
              >
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  onChange={(event) => uploadFiles(event, "listImage")}
                />
                <Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
              </IconButton>
              {item.listImage ? (
                <img
                  style={{
                    margin: "0 auto",
                    width: 100,
                    background: "grey",
                  }}
                  alt="Store item"
                  src={item.listImage}
                />
              ) : null}
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>Cancel</Button>
        <Button
          onClick={() => onSuccess()}
          autoFocus
          disabled={
            item === null || !item.name || !item.description || !item.image
          }
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
